import { render } from "./VerticalCategoryMenu.vue?vue&type=template&id=03e4dbd4&scoped=true"
import script from "./VerticalCategoryMenu.vue?vue&type=script&lang=js"
export * from "./VerticalCategoryMenu.vue?vue&type=script&lang=js"

import "./VerticalCategoryMenu.vue?vue&type=style&index=0&id=03e4dbd4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e4dbd4"]])

export default __exports__